<template>
  <v-container grid-list-xl v-if="oneCheck">
    <v-text-field readonly label="Cliente" :value="oneCheck.data.attributes.client_name"></v-text-field>
    <v-row justify="space-around">
      <v-col cols='5'>
        <v-text-field readonly label="Pago em" :value="oneCheck.data.attributes.payed"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Confirmado em" :value="oneCheck.data.attributes.confirmed"></v-text-field>
      </v-col>
      <v-col cols='6'>
        <v-text-field readonly label="Confirmado por" :value="oneCheck.data.attributes.confirmed_by"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Depositado em" :value="oneCheck.data.attributes.deposited_date"></v-text-field>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-expansion-panels v-if="oneCheck != null" popout multiple flat active-class="elevation-4">
      <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
        <v-expansion-panel-header class="red--text font-weight-bold">Informações do cheque</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container grid-list-xl>
            <v-text-field readonly label="Banco" :value="oneCheck.data.attributes.bank"></v-text-field>
            <v-text-field readonly label="Agencia" :value="oneCheck.data.attributes.whole_agency"></v-text-field>
            <v-text-field readonly label="Conta" :value="oneCheck.data.attributes.whole_account"></v-text-field>
            <v-text-field readonly label="Num. Cheque" :value="oneCheck.data.attributes.check_number"></v-text-field>
            <v-text-field readonly label="Bom para" :value="oneCheck.data.attributes.good_to"></v-text-field>
            <v-text-field readonly label="Valor" prefix="R$ " v-money="money"
              :value="oneCheck.data.attributes.value"></v-text-field>
            <v-text-field readonly label="Nominal" :value="oneCheck.data.attributes.nominal"></v-text-field>
            <v-text-field readonly label="CPF Nominal" v-mask="'###.###.###-##'"
              :value="oneCheck.data.attributes.nominal_cpf" v-if="oneCheck.data.attributes.nominal_cpf"></v-text-field>
            <v-text-field readonly label="CNPJ Nominal" v-mask="'##.###.###/####-##'"
              :value="oneCheck.data.attributes.nominal_cnpj"
              v-if="oneCheck.data.attributes.nominal_cnpj"></v-text-field>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
        <v-expansion-panel-header class="red--text font-weight-bold">Anexos</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container grid-list-xl>
            <v-btn :disabled="!isFinancials" v-if="front || back" rounded block color="success" class="font-weight-bold"
              @click="updateDocuments()">
              <v-icon left style="font-size: 22px">fa-save</v-icon> Atualizar anexos
            </v-btn>
            <template name="front">
              <div class="mt-2 mb-2">
                <input type="file" accept="application/pdf, image/*" style="display: none" id="file" ref="file"
                  @change="handleFile('frente')">
              </div>
              <v-btn :disabled="!isFinancials" rounded color="info" class="font-weight-bold" @click="$refs.file.click()">
                <v-icon left style="font-size: 22px">fa-camera-retro</v-icon> {{
                  oneCheck.data.attributes.front ?
                    'Alterar' : 'Adicionar'
                }} frente
              </v-btn>
              <template v-if="oneCheck.data.attributes.front && !front">
                <iframe v-if="oneCheck.data.attributes.front.data.attributes.kind.includes('pdf') && !isMobile"
                  :src="oneCheck.data.attributes.front.data.attributes.document" width="400" height="500"></iframe>
                <v-img v-if="oneCheck.data.attributes.front.data.attributes.kind.includes('ima')"
                  :src="oneCheck.data.attributes.front.data.attributes.document" contain></v-img>
                <v-btn text small color="primary"
                  @click="downloadDocument(oneCheck.data.attributes.front.data.attributes.document)" rouded><v-icon left
                    small>fa-download</v-icon> Baixar Documento</v-btn>
              </template>
              <template v-if="front">
                <iframe v-if="attachment_attributes[0].type.includes('pdf') && !isMobile" :src="front" width="400"
                  height="500"></iframe>
                <v-img v-if="attachment_attributes[0].type.includes('ima')" :src="front" contain></v-img>
                <v-list>
                  <!-- <v-list-item v-for="(f,id) in driver.cnhFile" :key="id"> -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ attachment_attributes[0].name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn text icon @click="removeFile('frente')"> <v-icon small color="red">fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </template>
            </template> <!-- FRENTE -->
            <template v-if="true" name="back">
              <div class="mt-2 mb-2">
                <input type="file" accept="application/pdf, image/*" style="display: none" id="file" ref="fileB"
                  @change="handleFile('tras')">
              </div>
              <v-btn v-if="can_show_actions" :disabled="!isFinancials" rounded color="info" class="font-weight-bold"
                @click="$refs.fileB.click()">
                <v-icon left style="font-size: 22px">fa-camera-retro</v-icon> {{
                  oneCheck.data.attributes.back ?
                    'Alterar' : 'Adicionar'
                }} costas
              </v-btn>
              <template v-if="oneCheck.data.attributes.back && !back">
                <iframe v-if="oneCheck.data.attributes.back.data.attributes.kind.includes('pdf') && !isMobile"
                  :src="oneCheck.data.attributes.back.data.attributes.document" width="400" height="500"></iframe>
                <v-img v-if="oneCheck.data.attributes.back.data.attributes.kind.includes('ima')"
                  :src="oneCheck.data.attributes.back.data.attributes.document" contain></v-img>
                <v-btn text small color="primary"
                  @click="downloadDocument(oneDeposit.data.attributes.document.data.attributes.document)" rouded><v-icon
                    left small>fa-download</v-icon> Baixar Documento</v-btn>
              </template>
              <template v-if="can_show_actions && back">
                <iframe v-if="attachment_attributes[1].type.includes('pdf') && !isMobile" :src="back" width="400"
                  height="500"></iframe>
                <v-img v-if="attachment_attributes[1].type.includes('ima')" :src="back" contain></v-img>
                <v-list>
                  <!-- <v-list-item v-for="(f,id) in driver.cnhFile" :key="id"> -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ attachment_attributes[1].name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn text icon @click="removeFile('tras')" v-if="can_show_actions"> <v-icon small
                          color="red">fa-trash-alt</v-icon> </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </template>
            </template> <!-- BACK -->

          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-btn v-if="front || back" rounded block color="success" class="font-weight-bold" @click="updateDocuments()">
        <v-icon left style="font-size: 22px">fa-save</v-icon> Atualizar anexos
      </v-btn>
    </v-expansion-panels>
    <v-divider></v-divider>
    <v-row justify="space-around" v-if="can_show_actions">
      <template v-if="!oneCheck.data.attributes.confirmed_at">
        <v-col cols='6'>
          <v-btn :disabled="!isFinancials" block rounded class="font-weight-bold" color="info" @click="deposit_check()">
            <v-icon left style="font-size: 22px">fa-check</v-icon> Depositar</v-btn>
        </v-col>
      </template>
      <template
        v-if="oneCheck.data.attributes.confirmed_at && (!oneCheck.data.attributes.concluded_at && !oneCheck.data.attributes.returned_due)">
        <v-col cols='6' v-if="false">
          <v-btn :disabled="!isFinancials" block rounded class="font-weight-bold" color="success"
            @click="conclude_check()"> <v-icon left style="font-size: 22px">fa-vote-yea</v-icon> Em conta</v-btn>
        </v-col>
      </template>
      <v-col cols='6'>
        <v-btn :disabled="!isFinancials || oneCheck.data.attributes.returned_check" block rounded
          class="font-weight-bold mt-2" color="error" @click="dialogReturn = true"
        > 
          <v-icon leftstyle="font-size: 22px">fa-exclamation-circle</v-icon> 
          Problema
        </v-btn>
      </v-col>
      <template
        v-if="oneCheck.data.attributes.confirmed_at && (oneCheck.data.attributes.concluded_at || oneCheck.data.attributes.returned_due)">
        <v-col cols='10'>
          <v-alert :type="oneCheck.data.attributes.returned ? 'error' : 'success'" :value="true">
            <h3> {{ oneCheck.data.attributes.returned ? 'Depósito extornado' : 'Depósito em conta' }} </h3>
          </v-alert>
        </v-col>
      </template>



      <v-col cols='6' v-if="false">
        <v-btn block class="font-weight-bold" color="success" @click="conclude_check()"> <v-icon left
            style="font-size: 22px">fa-vote-yea</v-icon> Em conta</v-btn>
      </v-col>
      <v-col cols='6' v-if="false">
        <v-btn block class="font-weight-bold" color="error" @click="dialogReturn = true"> <v-icon left
            style="font-size: 22px">fa-undo-alt</v-icon> Recusado</v-btn>
      </v-col>
    </v-row>




    <v-dialog v-model="dialogReturn" persistent max-width="400px" transition="dialog-transition">
      <v-card>
        <v-container grid-list-lg>
          <v-form ref='return_check_form' lazy-validation>
            <h2>Informe o código do problema/retorno</h2>
            <v-text-field label="Código do Motivo" v-mask="'##'" :rules="[rules.motive]" type='number'
              v-model="returned_due"></v-text-field>
            <v-textarea v-model="comment" prepend-icon="fa-comment fa-flip-horizontal" rows="3"
              label="Comentário"></v-textarea>
            <!-- <v-text-field ref="value_return" label="Valor (R$)" v-money="money" v-model="returned_value"></v-text-field> -->
            <v-divider></v-divider>
          </v-form>
          <v-row justify="space-around">
            <v-col cols='6'>
              <v-btn block rounded class="font-weight-bold" color="grey" dark @click="dialogReturn = false"> 
                <v-icon left style="font-size: 22px">fa-ban</v-icon> Cancelar
              </v-btn>
            </v-col>
            <v-col cols='6'>
              <v-btn block rounded class="font-weight-bold" color="error" @click="return_check()"
                :disabled="!returned_due">
                <v-icon left style="font-size: 22px">fa-exclamation-circle</v-icon> Relatar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>


    <v-dialog v-model="loading" persistent :overlay="false" max-width="500px" transition="dialog-transition">
      <v-card color="red darken-1" dark v-if="loading">
        <v-card-text>
          <v-col cols='12'>
            Salvando...
          </v-col>
          <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
          <v-col cols='12' class="mt-2">
            <v-progress-circular :size="70" :width="7" color="white" indeterminate></v-progress-circular>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { VMoney } from 'v-money'

export default {
  name: 'CheckProfile',
  directives: { money: VMoney },
  props: {
    can_show_actions: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },

      //returning
      dialogReturn: false,
      returned_due: null,
      comment: null,

      //files
      newAttachment: ['', ''],
      front: '',
      back: '',
      attachment_attributes: [{ type: 'null' }, { type: 'null' }],

      //saving
      loading: false,

      rules: {
        required: v => !!v || 'Campo é necessário',
        ck_number: v => !!v && v.length == 6 || 'Deve ter 6 dígitos. Ex: 000123',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v => v != '0.00' || 'Não pode ser zero',
        motive: v => !!v && (v >= 10 && v <= 99) || 'Deve ser entre 10 e 99',
      },

      //fake for tests
      oneCheck_2: {
        data: {
          attributes: {
            client_name: 'joao',
            payed: '12/12/2109',
            confirmed: '13/12/2019',
            confirmed_by: 'alessandra',
            bank: 'aaa',
            agency: 'aaa',
            account_number: 'aaa',
            check_number: 'aaa',
            good_to: 'aaa',
            value: '12773.50',
            nominal: 'aaa',
            nominal_cpf: 'aaa',

            returned: true,
            returned_due: 'cheque deu algum problema',
            returned_value: '4568.42',
            attachment2: null,
            attachment: {
              data: {
                attributes: {
                  type: 'ima',
                  url: 'https://timeline.canaltech.com.br/272460.700/ct-news-16022018-google-remove-botao-ver-imagem-da-busca.jpg',
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    downloadDocument(url) {
      window.open(url, '_blank')
    },
    updateDocuments() {
      var { id, concluded_at, concluded_by_id, returned, status_id, attachments_attributes, document } = this.oneCheck.data.attributes

      // attachment_attributes.id = document.data.id

      var obj_deposit = {
        id,
        // concluded_at,
        // concluded_by_id,
        // returned,
        // status_id,
        attachments_attributes
      }

      this.loading = true

      this.updateCheck({
        financial: obj_deposit
      })
    },
    deposit_check() {
      // not used because it is confirmed in the envelope..
      var now = new Date().toISOString()
      var { id, deposited_at, deposited, attachment_attributes } = this.oneCheck.data.attributes
      deposited_at = now.substring(0, 10) + ' ' + now.substring(11, 19)
      deposited = true
      var status_id = this.confirmed_id

      var obj_check = {
        id,
        deposited_at,
        deposited,
        status_id,
        attachment_attributes
      }

      this.loading = true

      this.updateCheck({
        financial: obj_check
      })
    },
    conclude_check() {
      var now = new Date().toISOString()
      var { id, concluded_at, concluded_by_id, returned, status_id, attachment_attributes } = this.oneCheck.data.attributes
      concluded_at = now.substring(0, 10) + ' ' + now.substring(11, 19)
      concluded_by_id = this.profile.included[0].id
      returned = false
      status_id = this.concluded_id

      var obj_check = {
        id,
        concluded_at,
        concluded_by_id,
        returned,
        status_id,
        attachment_attributes
      }

      this.loading = true

      this.updateCheck({
        financial: obj_check
      })
    },
    return_check() {
      if (this.$refs.return_check_form.validate()) {
        var { id, returned, returned_due, attachment_attributes, check_number, value } = this.oneCheck.data.attributes
        returned = true
        returned_due = this.returned_due

        var obj_check = {
          id,
          returned,
          returned_due,
          attachment_attributes,
          returned_check_attributes: {
            comment: this.comment,
            number: check_number,
            motive: returned_due,
            value: value,
            returned_by: this.profile.data.attributes.name,
          }
        }
        this.loading = true
        this.updateCheck({
          financial: obj_check
        })
      }
    },
    handleFile(side) {
      var uploadedFiles = side.includes('fr') ? this.$refs.file.files : this.$refs.fileB.files
      var doc_index = side.includes('fr') ? 0 : 1
      //for( var i = 0; i < uploadedFiles.length; i++ ){
      // this.driver.cnhFile.push(uploadedFiles[i]);
      //}
      this.attachment_attributes[doc_index] = uploadedFiles[0];
      var fileReader = new FileReader()

      var attachments_attributes = []


      fileReader.addEventListener('load', () => {
        this.newAttachment[doc_index] = fileReader.result
        side.includes('fr') ? this.front = fileReader.result : this.back = fileReader.result

        this.oneCheck.data.attributes.attachments_attributes[doc_index] = {
          url_document: fileReader.result,
          name: side,
          kind: this.attachment_attributes[doc_index].type,
          id: (side.includes('fr') && this.oneCheck.data.attributes.front) ? this.oneCheck.data.attributes.front.data.id
            : (!side.includes('fr') && this.oneCheck.data.attributes.back) ? this.oneCheck.data.attributes.back.data.id
              : null
        }
      })

      // fileReader.readAsDataURL(this.driver.cnhFile[0])
      fileReader.readAsDataURL(this.attachment_attributes[doc_index])
    },
    removeFile(side) {
      //this.driver.cnhFile.splice(i,1)
      var doc_index = side.includes('fr') ? 0 : 1
      side.includes('fr') ? this.front = '' : this.back = ''

      this.oneCheck.data.attributes.attachments_attributes[doc_index] = {}
      this.attachment_attributes[doc_index] = {}
      // this.newAttachment[doc_index] = ''

    },
    snackControl(type, msg) {
      this.addNotification({type, msg})
    },
    ...mapActions({
      
      showFinancial: 'Financial/show',
      cleanVrtTrans: 'Financial/cleanVrtTrans',
      getChecks: 'Financial/indexCheck',
      updateCheck: 'Financial/updateCheck',
    })
  },
  computed: {
    payed_id() {
      var payed = this.allStatuses.map(status => status.attributes.title).indexOf('Payed')

      payed = this.allStatuses[payed].attributes

      return 1 //payed.id
    },
    concluded_id() {
      var concluded = this.allStatuses.map(status => status.attributes.title).indexOf('Concluded')

      concluded = this.allStatuses[concluded].attributes

      return concluded.id
    },
    confirmed_id() {
      var confirmed = this.allStatuses.map(status => status.attributes.title).indexOf('Confirmed')

      confirmed = this.allStatuses[confirmed].attributes

      return confirmed.id
    },
    isMobile() {
      if (document.body.clientWidth < 700 && this.file.size)
        return true
      else
        return false
    },
    isFinancials() {
      return this.isFinancial() || this.isDirector()
    },
    ...mapState({
      profile: state => state.User.oneUser,

      allChecks: state => state.Financial.allChecks,
      oneCheck: state => state.Financial.oneCheck,

      update_was_good: state => state.Financial.update_was_good,
      update_message: state => state.Financial.update_message,

      allStatuses: state => state.Status.allStatuses,
    })
  },
  watch: {
    update_was_good(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false
        }, 1500);
        setTimeout(() => {
          this.snackControl('success', 'Cheque atualizado')

          this.showFinancial({ kind: 'checks', id: this.oneCheck.data.id })
          if (this.dialogReturn) {
            this.dialogReturn = false
          } else if (!this.dialogReturn) {
          }
        }, 2000);
      } else if (nv == false) {
        setTimeout(() => {
          this.loading = false
        }, 1500);
        setTimeout(() => {
          this.snackControl('error', 'Erro: ' + this.update_message)
        }, 2000);
      }
    },
    dialogReturn(nv, ov) {
      if (nv == false) {
        this.returned_due = null
      }
    },
    oneCheck(nv, ov) {
      if (nv) {
        this.oneCheck.data.attributes.attachments_attributes = []
        this.back = ''
        this.front = ''
        this.attachment_attributes = [{}, {}]
      }
    }
  },
  mounted() {
    this.oneCheck.data.attributes.attachments_attributes = []
    // console.log(this.oneCheck.data.attributes.attachments_attributes);
  },
}
</script>

<style scoped>

</style>
